import React from "react";
import Link from "next/link";
import { Pagination } from "@mui/material";
import {
  NewsImageCard,
  NewsVideoCard,
  NewsPopular,
  NewsSearch,
  NewsSubscription,
  NewsTags,
} from "@modules/study/common/news";
import { useMediaQuery } from "react-responsive";

import styles from "./list_section.module.scss";
import PaginationComponent from "@unisearch/common/ui_element/pagination";

export const GalleryListSection = ({
  format,
  newsList,
  tagsList,
  popularStories,
  handlePager,
  paginate,
}) => {
  const isMobile = useMediaQuery({
    query: "(max-width: 900px)",
  });

  const paginationHandler = (event, page) => {
    if (handlePager) {
      handlePager(page);
    }
  };

  return (
    <section>
      <div className="container">
        <div className={styles.list_wrapper}>
          <div className={styles.left_side}>
            {isMobile && (
              <NewsSearch
                customClasses={{
                  wrapperClass: styles.search_wrapper,
                }}
              />
            )}

            {/* List start */}
            {format === "gallery" && (
              <div className={styles.list_items}>
                {newsList &&
                  newsList?.length > 0 &&
                  newsList.map((item, i) => {
                    return (
                      <NewsImageCard
                        data={item}
                        key={i}
                        overlay={i === 0}
                        showDate={i !== 0}
                        customClasses={{
                          cardClass: styles.image_card,
                          headClass: styles.card_head,
                          featureImageClass: styles.card_feature_image,
                          bodyClass: styles.card_body,
                          titleClass: styles.card_title,
                          dateClass: styles.card_date,
                        }}
                      />
                    );
                  })}
              </div>
            )}
            {format === "video" && (
              <div className={styles.list_items}>
                {newsList &&
                  newsList?.length > 0 &&
                  newsList.map((item, i) => {
                    return (
                      <NewsVideoCard
                        data={item}
                        showDescription={i === 0}
                        key={i}
                        customClasses={{
                          cardClass: styles.video_item,
                          headClass: styles.video_head,
                          titleClass: styles.video_title,
                          descriptionClass: styles.video_description,
                          featureImageClass: styles.video_image_wrapper,
                        }}
                      />
                    );
                  })}
              </div>
            )}

            {/* Pagination start*/}
            {paginate && paginate.total > parseInt(paginate.limit) && (
              <PaginationComponent
                paginate={paginate}
                paginationHandler={paginationHandler}
              />
            )}
            {/* Pagination end*/}
          </div>
          <div className={styles.right_side}>
            {!isMobile && <NewsSearch />}
            <NewsSubscription />
            <NewsPopular data={popularStories} />
            <NewsTags format={format} tagsList={tagsList} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GalleryListSection;
